import styled from 'styled-components';

interface ITextValue {
  cursor: 'default' | 'pointer';
  textUnderline?: boolean;
}
export const Container = styled.div`
  padding: 0 0 2rem;

  > h2 {
    font-weight: bold;
  }
`;
export const ContainerSection = styled.div`
  background-color: #ECF1F6;
  padding: 1rem;
  border-radius: 6px;
  margin: 0 0 2rem 0;
`;
export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
`;

export const TextValue = styled.span<ITextValue>`
  display: block;
  text-align: center;
  text-decoration: ${props => (props.textUnderline ? 'underline' : 'default')};
  ${props =>
    props.cursor === 'default' &&
    `
    cursor: default;
    `}
  ${props =>
    props.cursor === 'pointer' &&
    `
    cursor: pointer;
    `}
`;

export const ContainerBoxGrid = styled.div`
  @media (max-width: 750px) {
    table {
      min-width: 750px;
    }
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 1rem;

  > button {
    max-width: 200px;
  }
`;
